import { InputNumberProps } from 'antd'
import type { ColumnType } from 'antd/es/table/interface'
import { useCallback } from 'react'

import { useNumberRangeFilter } from './useColumnNumberRangeFilter'

export const getDynamicStep = (value: number | null | undefined): number => {
  if (!value) return 1
  const absValue = Math.abs(value)

  if (absValue >= 10_000_000) return 1_000_000
  if (absValue >= 1_000_000) return 100_000
  if (absValue >= 100_000) return 10_000
  if (absValue >= 10_000) return 1_000
  if (absValue >= 1_000) return 100
  if (absValue >= 100) return 10
  return 1
}

const defaultMoneyConfig: InputNumberProps = {
  addonAfter: 'Kč',
}

/**
 * client-side Ant Table columns filter by Money range with default "Kč" symbol.
 * This is a convenience wrapper around useNumberRangeFilter.
 */
export function useMoneyRangeFilter<T>() {
  const { getNumberRangeFilter } = useNumberRangeFilter<T>()

  const getMoneyRangeFilter = useCallback(
    (
      dataIndex: keyof T | [keyof T, ...string[]],
      configMin?: InputNumberProps,
      configMax?: InputNumberProps,
      parseToNumber = false
    ): ColumnType<T> => {
      return getNumberRangeFilter(
        dataIndex,
        { ...defaultMoneyConfig, ...configMin },
        { ...defaultMoneyConfig, ...configMax },
        parseToNumber,
        getDynamicStep
      )
    },
    [getNumberRangeFilter]
  )

  return { getMoneyRangeFilter }
}
